module.exports = __webpack_public_path__ + "static/12.3_classical_greece-4c2b9671ac4d2c05360800bbd63a060e.pdf";